module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/logo_sct_outil.71e16e18.png";